// extracted by mini-css-extract-plugin
export var alertIcon = "_nb-0";